import React from 'react';

const Header = () => (
  <tr>
    <th className="text-sm-left">Periods</th>
    <th className="text-sm-left">Temats</th>
    <th>Noma</th>
    <th>Ražošana</th>
    <th>Montāža un demontāža</th>
    <th>Nodeva</th>
    <th>Kopā</th>
  </tr>
);

export default Header;


// WEBPACK FOOTER //
// ./src/containers/ProductBasket/Header.js